import React from "react";
import { withStyles } from "@material-ui/core";
import { compose } from "recompose";
import {
  getProDetails,
  totalValueGetter,
  returnCustomerName,
} from "../NextStopComplianceUtills";
import Tooltip from "../../../../common/StyledToolTip";
import appConstants from "../../../../../appConstants";
import StopInfoField from "./StopInfoField";

const styles = (theme) => ({
  headerText: {
    fontWeight: "bold",
    fontSize: theme.headerTextFontSize,
    color: theme.iconColor,
    lineHeight: "21px",
    margin: "19px 0px 10px 0px",
  },
  subHeaderText: {
    fontSize: theme.textFontSize,
    lineHeight: "16px",
    color: theme.iconColor,
    padding: "5px 0px 0px 28px",
    minWidth: "fit-content",
  },
  subHeaderTextBold: {
    fontWeight: "600",
    fontSize: theme.textFontSize,
    lineHeight: "16px",
    color: theme.iconColor,
    padding: "5px 0px 0px 5px",
  },
  redHeader: {
    fontWeight: "bold",
    fontSize: theme.headerTextFontSize,
    lineHeight: "22px",
    color: theme.deviationStopPopupColor,
  },
  leftPadding: {
    paddingLeft: "10px",
  },
  greenHeader: {
    fontWeight: "bold",
    fontSize: theme.headerTextFontSize,
    lineHeight: "22px",
    color: theme.ToggleIconColor,
  },
  ellipsisText: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "80%",
  },
  flexRow: {
    display: "flex",
  },
});

const StopInfo = ({
  classes,
  stopDetails,
  manifestNumber,
  isDeviation,
  stopLabel,
}) => {
  const customerName = returnCustomerName(stopDetails.data);
  const ProNumberString = (proArray) => {
    const proString = getProDetails(proArray);
    if (proArray.length <= 2) {
      return <div className={classes.subHeaderTextBold}>{proString} </div>;
    } else {
      let newProArray = [...proArray];
      return (
        <Tooltip title={<div>{proString}</div>}>
          <div className={classes.subHeaderTextBold}>
            {` ${getProDetails(newProArray.splice(0, 2))} +${
              newProArray.length
            } more`}
          </div>
        </Tooltip>
      );
    }
  };

  let loadingZones = [
    ...new Set(
      stopDetails.data.shipments.reduce((previousValue, currentValue) => {
        return currentValue.loadingZone
          ? [...previousValue, currentValue.loadingZone]
          : [...previousValue];
      }, [])
    ),
  ];
  
  return (
    <React.Fragment>
      <div className={classes.headerText}>{stopLabel}</div>
      <div className={classes.flexRow}>
        <div className={isDeviation ? classes.redHeader : classes.greenHeader}>
          {stopDetails.stopSequence}
          {stopDetails.data.stopType === appConstants.STOP_TYPE.Delivery
            ? "D"
            : "P"}
        </div>
        <Tooltip title={<div>{customerName}</div>}>
          <div
            className={`${
              isDeviation ? classes.redHeader : classes.greenHeader
            } ${classes.leftPadding} ${classes.ellipsisText}`}
          >
            {customerName}
          </div>
        </Tooltip>
      </div>
      <div className={classes.flexRow}>
        <div className={classes.subHeaderText}>Pro ID:</div>
        {ProNumberString(stopDetails.data.shipments)}
      </div>

      {loadingZones.length > 0 && (
        <StopInfoField
          classes={classes}
          fieldName="Loading Zone"
          fieldValue={loadingZones.join(", ")}
        ></StopInfoField>
      )}
      {stopDetails.data.stopType === appConstants.STOP_TYPE.Pickup && (
        <StopInfoField
          classes={classes}
          fieldName="Pickup Number"
          fieldValue={stopDetails.data.pickupNumber}
        ></StopInfoField>
      )}
      {stopDetails.data.receiverName && (
        <StopInfoField
          classes={classes}
          fieldName="Receiver"
          fieldValue={stopDetails.data.receiverName}
        ></StopInfoField>
      )}
      <StopInfoField
        classes={classes}
        fieldName="Manifest No"
        fieldValue={manifestNumber}
      ></StopInfoField>
      <StopInfoField
        classes={classes}
        fieldName="Address"
        fieldValue={stopDetails.data.address}
      ></StopInfoField>
      <div className={classes.flexRow}>
        <div className={classes.subHeaderText}>Weight :</div>
        <div className={classes.subHeaderTextBold}>
          {totalValueGetter(stopDetails.data, "weight")}
        </div>
        <div className={classes.subHeaderText}> PSE :</div>
        <div className={classes.subHeaderTextBold}>
          {totalValueGetter(stopDetails.data, "pse")}
        </div>
        <div className={classes.subHeaderText}> HU :</div>
        <div className={classes.subHeaderTextBold}>
          {totalValueGetter(stopDetails.data, "hu")}
        </div>
      </div>

      <StopInfoField
        classes={classes}
        fieldName={
          stopDetails.data.stopType === appConstants.STOP_TYPE.Delivery
            ? "Delivery Window"
            : "Pickup Window"
        }
        fieldValue={stopDetails.data.serviceWindow}
      ></StopInfoField>
      <StopInfoField
        classes={classes}
        fieldName="Arrival Time"
        fieldValue={stopDetails.arrivalTime}
      ></StopInfoField>
      <StopInfoField
        classes={classes}
        fieldName="Departure Time"
        fieldValue={stopDetails.departureTime}
      ></StopInfoField>
      {stopDetails.data.priority && (
        <StopInfoField
          classes={classes}
          fieldName="Priority"
          fieldValue={stopDetails.data.priority}
        ></StopInfoField>
      )}
    </React.Fragment>
  );
};
export default compose(withStyles(styles))(StopInfo);
